import {
  formatPrice
} from "./chunk--chunk-RUUZ7QV3.vbt.js";
import "./chunk--chunk-Z7A6LSGX.vbt.js";

// src/js/components/FreeShip.js
var FreeShip = class {
  constructor(el, sel) {
    this.el = el;
    this.threshold = parseInt(el.getAttribute(sel));
    this.progress = el.querySelector("[data-progress]");
    this.remaining = el.querySelector("[data-remaining]");
    this.content = el.querySelector("[data-freeship-content]");
    this.achievedContent = el.querySelector("[data-freeship-achieved]");
    this.attachListeners();
  }
  attachListeners() {
    const getPrice = async () => {
      const res = await fetch("/cart.js");
      const json = await res.json();
      this.updateElements(json.total_price);
    };
    document.addEventListener("ajaxcart refresh", getPrice);
    getPrice();
  }
  updateElements(cartPrice) {
    const newRemaining = (this.threshold - cartPrice) / 100;
    if (this.remaining) {
      this.remaining.innerHTML = formatPrice(newRemaining);
    }
    let percent = 100 - newRemaining * 100 / this.threshold * 100;
    if (percent == 0) {
      percent = 1;
    }
    this.progress.style.width = percent + "%";
    if (newRemaining > 0) {
      this.content.style.display = "block";
      this.achievedContent.style.display = "none";
    } else {
      this.content.style.display = "none";
      this.achievedContent.style.display = "block";
    }
  }
};
var FreeShip_default = FreeShip;
export {
  FreeShip_default as default
};
